import httpCommon from "./http-common";

// Get files by customer
const getFilesByCustomer = (customerId: number) => {
  return httpCommon.get(`/v1/get/files/customer/${customerId}`);
};

// Get files by deal
const getFilesByDeal = (dealId: number) => {
  return httpCommon.get(`/v1/get/files/deal/${dealId}`);
};

// Upload file
const uploadFile = (businessId: number, formData: FormData) => {
  return httpCommon.post(`/v1/upload/file/${businessId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// Delete file
const deleteFile = (fileId: number) => {
  return httpCommon.delete(`/v1/delete/file/${fileId}`);
};

// Download file
const downloadFile = (fileId: number) => {
  return httpCommon.get(`/v1/download/file/${fileId}`, {
    responseType: 'blob'
  });
};

const FileService = {
  getFilesByCustomer,
  getFilesByDeal,
  uploadFile,
  deleteFile,
  downloadFile
};

export default FileService; 